'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Error$PvpcontrollerWeb = require("./Error.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Loading$PvpcontrollerWeb = require("./Loading.js");
var Changelog$PvpcontrollerWeb = require("./Changelog.js");
var Debugging$PvpcontrollerWeb = require("../Debugging.js");
var WeaponModel$PvpcontrollerWeb = require("../models/WeaponModel.js");
var MobileDetect$PvpcontrollerWeb = require("../MobileDetect.js");
var EditableValue$PvpcontrollerWeb = require("./EditableValue.js");
var WeaponService$PvpcontrollerWeb = require("../services/WeaponService.js");

var baseContent_0 = Css.display("flex");

var baseContent_1 = {
  hd: Css.backgroundColor(Theme$PvpcontrollerWeb.panelColor),
  tl: {
    hd: Css.padding(Css.px(30)),
    tl: /* [] */0
  }
};

var baseContent = {
  hd: baseContent_0,
  tl: baseContent_1
};

var content = Curry._1(Css.style, {
      hd: Css.height(Css.px(190)),
      tl: baseContent
    });

var baseContentLoading_0 = Css.display("flex");

var baseContentLoading_1 = {
  hd: Css.backgroundColor(Css.hex("34373c")),
  tl: {
    hd: Css.padding(Css.px(30)),
    tl: /* [] */0
  }
};

var baseContentLoading = {
  hd: baseContentLoading_0,
  tl: baseContentLoading_1
};

var contentLoading = Curry._1(Css.style, {
      hd: Css.height(Css.px(190)),
      tl: baseContentLoading
    });

var leftPanel = Curry._1(Css.style, {
      hd: Css.minWidth(Css.px(200)),
      tl: /* [] */0
    });

var image = Curry._1(Css.style, {
      hd: Css.width(Css.px(50)),
      tl: {
        hd: Css.marginTop(Css.px(20)),
        tl: {
          hd: Css.marginLeft(Css.px(30)),
          tl: /* [] */0
        }
      }
    });

var name = Curry._1(Css.style, {
      hd: Css.fontSize(Css.px(25)),
      tl: {
        hd: Css.color(Css.hex("78a4ec")),
        tl: /* [] */0
      }
    });

var rightPanel = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.justifyContent(Css.spaceEvenly),
        tl: {
          hd: Css.flexGrow(1.0),
          tl: {
            hd: Css.marginTop(Css.px(40)),
            tl: {
              hd: Css.marginRight(Css.px(50)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var infoGroup = Curry._1(Css.style, /* [] */0);

var statEntry = Curry._1(Css.style, {
      hd: Css.marginBottom(Css.px(10)),
      tl: /* [] */0
    });

var content$1 = Curry._1(Css.style, {
      hd: Css.flexDirection(Css.column),
      tl: baseContent
    });

var contentLoading$1 = Curry._1(Css.style, {
      hd: Css.height(Css.rem(21.2)),
      tl: baseContentLoading
    });

var rightPanel$1 = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.flexWrap(Css.wrap),
        tl: {
          hd: Css.justifyContent(Css.spaceBetween),
          tl: {
            hd: Css.flexGrow(1.0),
            tl: {
              hd: Css.marginTop(Css.px(40)),
              tl: {
                hd: Css.marginRight(Css.px(50)),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var infoGroup$1 = Curry._1(Css.style, {
      hd: Css.padding2(Css.zero, Css.rem(0.5)),
      tl: /* [] */0
    });

function minMaxDamageDisplay(damageCap) {
  if (damageCap > -1) {
    return String(damageCap);
  } else {
    return "None";
  }
}

function weaponDetails(weapon, editMode, setState, session, setChangelogState) {
  var damage = String(weapon.damage);
  var velocity = String(weapon.velocity);
  var maxDamage = minMaxDamageDisplay(weapon.maxDamage);
  var minDamage = minMaxDamageDisplay(weapon.minDamage);
  var banned = weapon.banned ? "Yes" : "No";
  return React.createElement("div", {
              className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? content$1 : content
            }, React.createElement("div", {
                  className: leftPanel
                }, React.createElement("div", {
                      className: name
                    }, weapon.name), React.createElement("div", {
                      className: Theme$PvpcontrollerWeb.forCategory(weapon.category),
                      style: {
                        fontSize: "22px"
                      }
                    }, WeaponModel$PvpcontrollerWeb.categoryToString(weapon.category)), React.createElement("img", {
                      className: image,
                      src: weapon.image
                    })), React.createElement("div", {
                  className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? rightPanel$1 : rightPanel
                }, React.createElement("div", {
                      className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? infoGroup$1 : infoGroup
                    }, React.createElement(EditableValue$PvpcontrollerWeb.make, EditableValue$PvpcontrollerWeb.makeProps(statEntry, undefined, weapon, session, editMode, "Damage", damage, (function (param, param$1) {
                                var setState$1 = setState[1];
                                var state = setState[0];
                                var value = param$1.target.value;
                                param$1.target.value = "";
                                if (value === "vanilla") {
                                  if (typeof state === "number") {
                                    return ;
                                  }
                                  var weapon = state._0;
                                  Curry._1(param, (function (_previousState) {
                                          return /* WaitingChangeConfirm */1;
                                        }));
                                  return Curry._1(setState$1, (function (_previousState) {
                                                return /* Weapon */{
                                                        _0: {
                                                          netId: weapon.netId,
                                                          baseDamage: weapon.baseDamage,
                                                          baseVelocity: weapon.baseVelocity,
                                                          damage: weapon.baseDamage,
                                                          maxDamage: weapon.maxDamage,
                                                          minDamage: weapon.minDamage,
                                                          image: weapon.image,
                                                          velocity: weapon.velocity,
                                                          category: weapon.category,
                                                          banned: weapon.banned,
                                                          name: weapon.name
                                                        }
                                                      };
                                              }));
                                }
                                var number = Belt_Int.fromString(value);
                                if (typeof state === "number") {
                                  return ;
                                }
                                if (number === undefined) {
                                  return ;
                                }
                                var weapon$1 = state._0;
                                if (number !== weapon$1.damage) {
                                  Curry._1(param, (function (_previousState) {
                                          return /* WaitingChangeConfirm */1;
                                        }));
                                }
                                return Curry._1(setState$1, (function (_previousState) {
                                              return /* Weapon */{
                                                      _0: {
                                                        netId: weapon$1.netId,
                                                        baseDamage: weapon$1.baseDamage,
                                                        baseVelocity: weapon$1.baseVelocity,
                                                        damage: number,
                                                        maxDamage: weapon$1.maxDamage,
                                                        minDamage: weapon$1.minDamage,
                                                        image: weapon$1.image,
                                                        velocity: weapon$1.velocity,
                                                        category: weapon$1.category,
                                                        banned: weapon$1.banned,
                                                        name: weapon$1.name
                                                      }
                                                    };
                                            }));
                              }), WeaponService$PvpcontrollerWeb.updateWeaponDamage, (function (param) {
                                return Curry._1(setChangelogState, (function (_previousState) {
                                              return /* Loading */0;
                                            }));
                              }), undefined, undefined)), React.createElement(EditableValue$PvpcontrollerWeb.make, EditableValue$PvpcontrollerWeb.makeProps(statEntry, undefined, weapon, session, editMode, "Velocity", velocity, (function (param, param$1) {
                                var setState$1 = setState[1];
                                var state = setState[0];
                                var value = param$1.target.value;
                                param$1.target.value = "";
                                if (value === "vanilla") {
                                  if (typeof state === "number") {
                                    return ;
                                  }
                                  var weapon = state._0;
                                  Curry._1(param, (function (_previousState) {
                                          return /* WaitingChangeConfirm */1;
                                        }));
                                  return Curry._1(setState$1, (function (_previousState) {
                                                return /* Weapon */{
                                                        _0: {
                                                          netId: weapon.netId,
                                                          baseDamage: weapon.baseDamage,
                                                          baseVelocity: weapon.baseVelocity,
                                                          damage: weapon.damage,
                                                          maxDamage: weapon.maxDamage,
                                                          minDamage: weapon.minDamage,
                                                          image: weapon.image,
                                                          velocity: weapon.baseVelocity,
                                                          category: weapon.category,
                                                          banned: weapon.banned,
                                                          name: weapon.name
                                                        }
                                                      };
                                              }));
                                }
                                var number = Belt_Int.fromString(value);
                                if (typeof state === "number") {
                                  return ;
                                }
                                if (number === undefined) {
                                  return ;
                                }
                                var weapon$1 = state._0;
                                Curry._1(setState$1, (function (_previousState) {
                                        return /* Weapon */{
                                                _0: {
                                                  netId: weapon$1.netId,
                                                  baseDamage: weapon$1.baseDamage,
                                                  baseVelocity: weapon$1.baseVelocity,
                                                  damage: weapon$1.damage,
                                                  maxDamage: weapon$1.maxDamage,
                                                  minDamage: weapon$1.minDamage,
                                                  image: weapon$1.image,
                                                  velocity: number,
                                                  category: weapon$1.category,
                                                  banned: weapon$1.banned,
                                                  name: weapon$1.name
                                                }
                                              };
                                      }));
                                if (number !== weapon$1.velocity) {
                                  return Curry._1(param, (function (_previousState) {
                                                return /* WaitingChangeConfirm */1;
                                              }));
                                }
                                
                              }), WeaponService$PvpcontrollerWeb.updateWeaponVelocity, (function (param) {
                                return Curry._1(setChangelogState, (function (_previousState) {
                                              return /* Loading */0;
                                            }));
                              }), undefined, undefined))), React.createElement("div", {
                      className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? infoGroup$1 : infoGroup
                    }, React.createElement(EditableValue$PvpcontrollerWeb.make, EditableValue$PvpcontrollerWeb.makeProps(statEntry, undefined, weapon, session, editMode, "Max Damage", maxDamage, (function (param, param$1) {
                                var setState$1 = setState[1];
                                var state = setState[0];
                                var value = param$1.target.value;
                                if (value.length <= 0) {
                                  return ;
                                }
                                param$1.target.value = "";
                                var number = Belt_Int.fromString(value);
                                if (typeof state === "number") {
                                  return ;
                                }
                                var weapon = state._0;
                                if (number !== undefined) {
                                  Curry._1(setState$1, (function (_previousState) {
                                          return /* Weapon */{
                                                  _0: {
                                                    netId: weapon.netId,
                                                    baseDamage: weapon.baseDamage,
                                                    baseVelocity: weapon.baseVelocity,
                                                    damage: weapon.damage,
                                                    maxDamage: number,
                                                    minDamage: weapon.minDamage,
                                                    image: weapon.image,
                                                    velocity: weapon.velocity,
                                                    category: weapon.category,
                                                    banned: weapon.banned,
                                                    name: weapon.name
                                                  }
                                                };
                                        }));
                                  if (weapon.maxDamage !== number) {
                                    return Curry._1(param, (function (_previousState) {
                                                  return /* WaitingChangeConfirm */1;
                                                }));
                                  } else {
                                    return ;
                                  }
                                } else {
                                  Curry._1(setState$1, (function (_previousState) {
                                          return /* Weapon */{
                                                  _0: {
                                                    netId: weapon.netId,
                                                    baseDamage: weapon.baseDamage,
                                                    baseVelocity: weapon.baseVelocity,
                                                    damage: weapon.damage,
                                                    maxDamage: -1,
                                                    minDamage: weapon.minDamage,
                                                    image: weapon.image,
                                                    velocity: weapon.velocity,
                                                    category: weapon.category,
                                                    banned: weapon.banned,
                                                    name: weapon.name
                                                  }
                                                };
                                        }));
                                  if (weapon.maxDamage !== -1) {
                                    return Curry._1(param, (function (_previousState) {
                                                  return /* WaitingChangeConfirm */1;
                                                }));
                                  } else {
                                    return ;
                                  }
                                }
                              }), WeaponService$PvpcontrollerWeb.updateWeaponMaxDamage, (function (param) {
                                return Curry._1(setChangelogState, (function (_previousState) {
                                              return /* Loading */0;
                                            }));
                              }), undefined, undefined)), React.createElement(EditableValue$PvpcontrollerWeb.make, EditableValue$PvpcontrollerWeb.makeProps(statEntry, undefined, weapon, session, editMode, "Min Damage", minDamage, (function (param, param$1) {
                                var setState$1 = setState[1];
                                var state = setState[0];
                                var value = param$1.target.value;
                                if (value.length <= 0) {
                                  return ;
                                }
                                param$1.target.value = "";
                                var number = Belt_Int.fromString(value);
                                if (typeof state === "number") {
                                  return ;
                                }
                                var weapon = state._0;
                                if (number !== undefined) {
                                  Curry._1(setState$1, (function (_previousState) {
                                          return /* Weapon */{
                                                  _0: {
                                                    netId: weapon.netId,
                                                    baseDamage: weapon.baseDamage,
                                                    baseVelocity: weapon.baseVelocity,
                                                    damage: weapon.damage,
                                                    maxDamage: weapon.maxDamage,
                                                    minDamage: number,
                                                    image: weapon.image,
                                                    velocity: weapon.velocity,
                                                    category: weapon.category,
                                                    banned: weapon.banned,
                                                    name: weapon.name
                                                  }
                                                };
                                        }));
                                  if (weapon.minDamage !== number) {
                                    return Curry._1(param, (function (_previousState) {
                                                  return /* WaitingChangeConfirm */1;
                                                }));
                                  } else {
                                    return ;
                                  }
                                } else {
                                  Curry._1(setState$1, (function (_previousState) {
                                          return /* Weapon */{
                                                  _0: {
                                                    netId: weapon.netId,
                                                    baseDamage: weapon.baseDamage,
                                                    baseVelocity: weapon.baseVelocity,
                                                    damage: weapon.damage,
                                                    maxDamage: weapon.maxDamage,
                                                    minDamage: -1,
                                                    image: weapon.image,
                                                    velocity: weapon.velocity,
                                                    category: weapon.category,
                                                    banned: weapon.banned,
                                                    name: weapon.name
                                                  }
                                                };
                                        }));
                                  if (weapon.minDamage !== -1) {
                                    return Curry._1(param, (function (_previousState) {
                                                  return /* WaitingChangeConfirm */1;
                                                }));
                                  } else {
                                    return ;
                                  }
                                }
                              }), WeaponService$PvpcontrollerWeb.updateWeaponMinDamage, (function (param) {
                                return Curry._1(setChangelogState, (function (_previousState) {
                                              return /* Loading */0;
                                            }));
                              }), undefined, undefined))), React.createElement("div", {
                      className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? infoGroup$1 : infoGroup
                    }, React.createElement(EditableValue$PvpcontrollerWeb.make, EditableValue$PvpcontrollerWeb.makeProps(statEntry, undefined, weapon, session, editMode, "Banned", banned, (function (param, param$1) {
                                var state = setState[0];
                                var value = param$1.target.value;
                                if (value.length <= 0) {
                                  return ;
                                }
                                param$1.target.value = "";
                                var match = value.toLowerCase();
                                var banned;
                                switch (match) {
                                  case "1" :
                                  case "on" :
                                  case "y" :
                                  case "ye" :
                                  case "yes" :
                                      banned = true;
                                      break;
                                  default:
                                    banned = false;
                                }
                                if (typeof state === "number") {
                                  return ;
                                }
                                var weapon = state._0;
                                Debugging$PvpcontrollerWeb.info("Changing banned to " + (
                                      banned ? "true" : "false"
                                    ));
                                Curry._1(setState[1], (function (_previousState) {
                                        return /* Weapon */{
                                                _0: {
                                                  netId: weapon.netId,
                                                  baseDamage: weapon.baseDamage,
                                                  baseVelocity: weapon.baseVelocity,
                                                  damage: weapon.damage,
                                                  maxDamage: weapon.maxDamage,
                                                  minDamage: weapon.minDamage,
                                                  image: weapon.image,
                                                  velocity: weapon.velocity,
                                                  category: weapon.category,
                                                  banned: banned,
                                                  name: weapon.name
                                                }
                                              };
                                      }));
                                if (weapon.banned !== banned) {
                                  return Curry._1(param, (function (_previousState) {
                                                return /* WaitingChangeConfirm */1;
                                              }));
                                }
                                
                              }), WeaponService$PvpcontrollerWeb.updateWeaponBanned, (function (param) {
                                return Curry._1(setChangelogState, (function (_previousState) {
                                              return /* Loading */0;
                                            }));
                              }), undefined, undefined)))));
}

function Weapon(Props) {
  var id = Props.id;
  var editMode = Props.editMode;
  var session = Props.session;
  var match = React.useState(function () {
        return /* Loading */0;
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function () {
        return /* Loading */0;
      });
  var setChangelogState = match$1[1];
  React.useEffect((function () {
          return WeaponService$PvpcontrollerWeb.getWeapon(id, (function (weapon) {
                        if (weapon.TAG === /* Ok */0) {
                          var weapon$1 = weapon._0;
                          return Curry._1(setState, (function (_previousState) {
                                        return /* Weapon */{
                                                _0: weapon$1
                                              };
                                      }));
                        }
                        var err = weapon._0;
                        if (err.RE_EXN_ID === "Match_failure") {
                          var match = err._1;
                          Debugging$PvpcontrollerWeb.messageWithData("Weapon-PvpcontrollerWeb" + (":getWeapon Could not destructure weapon type. Failed at " + match[0] + ":L" + match[1].toString() + "_C" + match[2].toString()), {
                                tags: (function (prim) {
                                    return {};
                                  }),
                                extra: err
                              });
                        } else {
                          Debugging$PvpcontrollerWeb.messageWithData("Weapon-PvpcontrollerWeb:getWeapon Could not get weapon.", {
                                tags: (function (prim) {
                                    return {};
                                  }),
                                extra: err
                              });
                        }
                        return Curry._1(setState, (function (_previousState) {
                                      return /* LoadingFailed */1;
                                    }));
                      }));
        }), []);
  var stateHook = [
    state,
    setState
  ];
  return React.createElement("div", {
              className: Theme$PvpcontrollerWeb.limitedWidthCard
            }, React.createElement("h2", {
                  className: Theme$PvpcontrollerWeb.title
                }, "Weapon Details"), typeof state === "number" ? (
                state !== 0 ? React.createElement(Error$PvpcontrollerWeb.make, Error$PvpcontrollerWeb.makeProps(undefined, undefined)) : React.createElement("div", {
                        className: MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? contentLoading$1 : contentLoading
                      }, React.createElement(Loading$PvpcontrollerWeb.make, Loading$PvpcontrollerWeb.makeProps(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)))
              ) : weaponDetails(state._0, editMode, stateHook, session, setChangelogState), React.createElement("h2", {
                  className: Theme$PvpcontrollerWeb.title
                }, "Changelog"), React.createElement(Changelog$PvpcontrollerWeb.make, Changelog$PvpcontrollerWeb.makeProps((function (param, param$1, param$2) {
                        return WeaponService$PvpcontrollerWeb.getWeaponChangelog(id, param, param$1, param$2);
                      }), true, match$1[0], setChangelogState, undefined, undefined, undefined, undefined, undefined)));
}

function makeProps(prim0, prim1, prim2, prim3, prim4) {
  var tmp = {
    id: prim0,
    editMode: prim1,
    session: prim2
  };
  if (prim3 !== undefined) {
    tmp.key = prim3;
  }
  return tmp;
}

var make = Weapon;

exports.makeProps = makeProps;
exports.make = make;
/* baseContent Not a pure module */
